import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {WEBBACK_V2_API} from "@constants";
import {isEmpty, evolutionDataFilters, elementsInLoading, dataDetails, dataDetailsFiltered, filterBrandTitle} from "../../../@signals"


export default function useShareOfSearchdataDetails() {
	const { showToast } = useAppToast()

	const isLoading = useSignal(false)

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			dataDetails.value = []
			dataDetailsFiltered.value = []
			filterBrandTitle.value = ""
			evolutionDataFilters.value = {}
			isLoading.value = true
			postSubmit(`${WEBBACK_V2_API}/share-of-search/keyword-details/context`, { ...commonFiltersValue.value }).then(res => {
				if (!res.data?.length) isEmpty.value = true
				dataDetails.value = res.data
			}).catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => {
				isLoading.value = false
				if (isEmpty.value) isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'tableDetails']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'tableDetails')
	}, [isLoading.value])

	return {
		isLoading: isLoading.value
	}
}